export default "/images/telegram.svg?612f273bfe1b0781142265527bf414fb";